import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, withCtx as _withCtx } from "vue";
var _hoisted_1 = {
  class: "live-detail"
};
var _hoisted_2 = {
  key: 0,
  class: "hero-fallback"
};
var _hoisted_3 = ["src"];
var _hoisted_4 = {
  class: "hero-info"
};
var _hoisted_5 = {
  class: "live-title"
};
var _hoisted_6 = {
  class: "bottom"
};
var _hoisted_7 = {
  class: "loading"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_WechatOpenLaunchApp = _resolveComponent("WechatOpenLaunchApp");
  var _component_van_loading = _resolveComponent("van-loading");
  var _component_van_overlay = _resolveComponent("van-overlay");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
    class: "hero",
    style: _normalizeStyle($options.heroStyle)
  }, [_cache[4] || (_cache[4] = _createElementVNode("div", {
    class: "hero-mask",
    "aria-hidden": "true"
  }, null, -1)), !$options.coverUrl ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("img", {
    src: $data.logo,
    alt: "logo",
    class: "hero-logo"
  }, null, 8, _hoisted_3)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_4, [_cache[2] || (_cache[2] = _createElementVNode("div", {
    class: "live-badge"
  }, [_createElementVNode("span", {
    class: "live-dot",
    "aria-hidden": "true"
  }), _createTextVNode(" 直播中 ")], -1)), _createElementVNode("div", _hoisted_5, _toDisplayString($options.titleText), 1), _cache[3] || (_cache[3] = _createElementVNode("div", {
    class: "live-sub"
  }, "起泡主播正在直播，快来围观吧", -1))])], 4), _createElementVNode("div", _hoisted_6, [_ctx.useWechatOpenLaunchApp ? (_openBlock(), _createBlock(_component_WechatOpenLaunchApp, {
    key: 0,
    "app-id": _ctx.wechatOpenLaunchAppId,
    extinfo: $options.wxLiveExtinfo,
    "button-text": "打开App观看",
    variant: "pill"
  }, null, 8, ["app-id", "extinfo"])) : (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: "open-btn",
    onClick: _cache[0] || (_cache[0] = function () {
      return $options.onOpenInApp && $options.onOpenInApp.apply($options, arguments);
    })
  }, "打开App观看")), _createElementVNode("a", {
    class: "download-link",
    href: "javascript:void(0)",
    onClick: _cache[1] || (_cache[1] = function () {
      return $options.goDownload && $options.goDownload.apply($options, arguments);
    })
  }, "没有安装起泡App？去下载")]), _createVNode(_component_van_overlay, {
    show: $data.opening
  }, {
    default: _withCtx(function () {
      return [_createElementVNode("div", _hoisted_7, [_createVNode(_component_van_loading, {
        size: "24",
        color: "#fff"
      }), _cache[5] || (_cache[5] = _createElementVNode("div", {
        class: "loading-text"
      }, "正在打开 App...", -1))])];
    }),
    _: 1
  }, 8, ["show"])]);
}